import React from 'react';
import { Row, Col } from 'antd';
import CountUp from 'react-countup';
import resources from '../resources';
import languages from '../appdata/languages';
import StoreManager from '../appdata';
import StatItem1 from './BaseComponents/StatItem1';
import StatItem2 from './BaseComponents/StatItem2';
import StatItem3 from './BaseComponents/StatItem3';
class FinancialMetrics extends React.Component {
  render() {
    const isMobile = window.innerWidth < 768;
    const backgroundImage = isMobile
      ? resources.images.financialbgmobile
      : resources.images.financialbg;

    const lg = StoreManager.appState.thisApp.state.currentLanguage;
    const lang = languages[lg].FinancialMetricsContent;
    const content = languages[lg].Highlight2024Content;

    return (
      <section
        style={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          padding: isMobile ? '40px 16px' : '80px 40px',
          color: '#1A1A1A',
        }}
      >
        <div style={{ maxWidth: 1040, margin: '0 auto' }}>
          <h2 style={{ fontSize: 36, fontWeight: 500, marginBottom: 40 }}>
            {lang.title}
          </h2>
          <Row>
            <h3 style={{ fontSize: 24, fontWeight: 600, marginBottom: 16 }}>{content.section1Title}</h3>
          </Row>

          <Row gutter={[16, 16]}>
            <Col xs={24} md={12} style={{ width: '100%' }}>

              <StatItem1
                iconName={resources.icons.FinancialIcon1}
                title={content.item1.title}
                value={content.item1.value}
                message1={content.item1.message1}
                message2={content.item1.message2}
                colorValue="#E0582C"
                colorMessage1="#212121"
                colorMessage2="#1DAA45"
             bgColor='rgba(255,255,255,0.5)'
                bgColor2='rgba(255,255,255,0)'
                isBorder={true}
              />
            </Col>
            <Col xs={24} md={12} style={{ width: '100%' }}>
              <StatItem1
                iconName={resources.icons.FinancialIcon2}
                title={content.item2.title}
                value={content.item2.value}
                message1={content.item2.message1}
                message2={content.item2.message2}
                colorValue="#E0582C"
                colorMessage1="#212121"
                colorMessage2="#212121"
                 bgColor='rgba(255,255,255,0.5)'
                bgColor2='rgba(255,255,255,0)'
                isBorder={true}
              />
            </Col>
            <Col xs={24} md={12} style={{ width: '100%' }}>

              <StatItem2
                iconName={resources.icons.FinancialIcon3}
                title={content.item3.title}
                value={content.item3.value}
                message1={content.item3.message1}
                message2=""
                message3=""
                colorValue="#E0582C"
                colorMessage1="#212121"
                colorMessage2="#212121"
                bgColor='rgba(255,255,255,0.5)'
                bgColor2='rgba(255,255,255,0)'
                isBorder={true}
              />

            </Col>
            <Col xs={24} md={12} style={{ width: '100%' }}>
              <StatItem2
                iconName={resources.icons.FinancialIcon4}
                title={content.item4.title}
                value={content.item4.value}
                message1={content.item4.message1}
                message2=""
                message3={content.item4.message3}
                colorValue="#E0582C"
                 bgColor='rgba(255,255,255,0.5)'
                bgColor2='rgba(255,255,255,0)'
                isBorder={true}

              />

            </Col>
          </Row>

          {
            !isMobile ? <>
              <div style={{
                display: 'flex',
                flexDirection: isMobile ? 'column' : 'row',
                gap: 16,
                marginTop: 80,
              }}>

                <div style={{
                  flex: 2,
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 16,
                }}>
                  <h3 style={{ fontSize: 24, fontWeight: 600, marginBottom: 16 }}>
                    {content.section2Title}
                  </h3>


                </div>

                <div style={{
                  flex: 1,
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 16,
                }}>
                  <h3 style={{ fontSize: 24, fontWeight: 600, marginBottom: 16 }}>
                    {content.section3Title}
                  </h3>

                </div>

              </div>
              <div style={{
                display: 'flex',
                flexDirection: isMobile ? 'column' : 'row',
                gap: 16,
              }}>

                <div style={{
                  flex: 2,
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 16,
                }}>
                  <StatItem3
                    title={content.item5.title}
                    value={content.item5.value}
                    message1={content.item5.message1}
                     bgColor='rgba(255,255,255,0.5)'
                bgColor2='rgba(255,255,255,0)'
                    type={2}
                    isBorder={true}

                  />

                  <StatItem3
                    title={content.item6.title}
                    value={content.item6.value}
                    message1={content.item6.message1}
                    bgColor='rgba(255,255,255,0.5)'
                bgColor2='rgba(255,255,255,0)'
                    type={2}
                    isBorder={true}

                  />
                </div>

                <div style={{
                  flex: 1,
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 16,
                }}>
                  <StatItem3
                    title={content.item7.title}
                    value={content.item7.value}
                    message1={content.item7.message1}
                     bgColor='rgba(255,255,255,0.5)'
                bgColor2='rgba(255,255,255,0)'
                    isBorder={true}

                  />
                </div>

              </div>

            </> :
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: 16,
                marginTop: 80,
              }}>

                <div style={{
                  flex: 2,
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 16,
                }}>
                  <h3 style={{ fontSize: 24, fontWeight: 600, marginBottom: 16 }}>
                    {content.section2Title}
                  </h3>

                  <StatItem3
                    title={content.item5.title}
                    value={content.item5.value}
                    message1={content.item5.message1}
                     bgColor='rgba(255,255,255,0.5)'
                bgColor2='rgba(255,255,255,0)'
                    type={2}
                    isBorder={true}
                  />

                  <StatItem3
                    title={content.item6.title}
                    value={content.item6.value}
                    message1={content.item6.message1}
                     bgColor='rgba(255,255,255,0.5)'
                bgColor2='rgba(255,255,255,0)'
                    type={2}
                    isBorder={true}

                  />
                </div>

                <div style={{
                  flex: 1,
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 16,
                }}>
                  <h3 style={{ fontSize: 24, fontWeight: 600, marginBottom: 16 }}>
                    {content.section3Title}
                  </h3>

                  <StatItem3
                    title={content.item7.title}
                    value={content.item7.value}
                    message1={content.item7.message1}
                    bgColor='rgba(255,255,255,0.5)'
                bgColor2='rgba(255,255,255,0)'
                    isBorder={true}

                  />
                </div>

              </div>
          }



        </div>
      </section>
    );
  }
}

export default FinancialMetrics;
